<div class="footer">
    <p>&copy;Todos los derechos reservados - Página realizada por el equipo de <span>X-Code</span></p>
</div>